import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetMedia =
  ({ type, related_id, callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: { type, related_id },
        Route: UrlApi.media.get,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageMedia =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const bodyFormData = new FormData();
      
      if (editMode && values?.id) {
        bodyFormData.append("id", values.id);
      }
      
      bodyFormData.append("type", values.type);
      bodyFormData.append("related_id", values.related_id);
      
      if (values.link) {
        if (values.link instanceof File) {
            bodyFormData.append("link", values.link);
        } else if (typeof values.link === "string") {
            bodyFormData.append("link", values.link); 
        }
    }

      const route = editMode ? UrlApi.media.edit : UrlApi.media.add;
      
      const response = await PostFunction({
        data: bodyFormData,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditMedia =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("id", id);
      formData.append(nameFailed, dataFailed);
      
      const response = await PostFunction({
        data: formData,
        Route: UrlApi.media.edit,
        showalert: true,
        state: getState,
        isMultipart: nameFailed === "link",
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteMedia =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));

      // Ensure we always send an object with idsmedia array
      const requestData = { idsmedia: Array.isArray(id) ? id : [id] };

      const response = await PostFunction({
        data: requestData, 
        Route: UrlApi.media.delete,
        showalert: true,
        state: getState,
        dispatch,
        isMultipart:false
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };